export const generateFullName = (data) => {
  const title = data?.title || data?._contact_title_ || data?.group_name;
  const nameParts = [title, data?.first_name, data?.middle_name, data?.last_name].filter(Boolean);
  const fullName = nameParts.join(' ');

  return fullName;
};
